export default __webpack_public_path__ + "static/media/Firma_Maritza_Nieto.43227ecd.png";